///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { API, CancelToken } from "../api/axios";
import { stringify } from "query-string";

let cancelGetLocationsToken;

export const getLocations = searchTerm => {
  cancelGetLocationsToken && cancelGetLocationsToken("Cancelled By User");

  return API.get("api/v1.0/locations/search?" + stringify({ searchTerm }), {
    cancelToken: new CancelToken(function executor(cancelToken) {
      cancelGetLocationsToken = cancelToken;
    })
  });
};
